<template>
  <div>
    <card v-if="maintenanceYsYSalesNavigator">
      <p>
        We are currently facing some technical issues with our Sales Navigator automation, The
        system administration team is looking into it and we should get it fixed ASAP.<br><br>
        This is caused by LinkedIn making changes to Sales Navigator. This happens from time to time
        but as soon as we are aware of an issue, we get to work on producing a fix which is rolled
        out to our user smoothly<br>
        The remaining features of YourSynchronicity are all working as expected, you can launch a
        free LinkedIn search by going to
        <router-link :to="{name:'Set LinkedIn configuration'}">Set new configuration</router-link>
        <br><br>
        Note: the main difference between Sales navigator and free LinkedIn is the limit per day
        (85vs65 per day)
      </p>
    </card>
    <form-wizard v-else @on-complete="resetForm" shape="square" stepSize="lg" color="#11cdef"
                 @on-loading="setLoading"
                 @on-validate="handleValidation"
                 ref="SalesLinkedinConfigurationWizard"
                 @on-error="handleErrorMessage" :title="''" :subtitle="''">

      <tab-content :title=step1
                   icon="fas fa-search-dollar fa-2x" :before-change="validateAsync">
        <card>
          <label for="savedSearch">Name your search:</label>
          <input v-model="configuration.ysySearchName" type="text"
                 placeholder=''
                 id="ysysearchname" class="form-control form-control-lg" height="100%">
          <p style="color: red" v-if="errorMissingYsySearchName">Please name your search to identify
            it afterwards.</p>
          <label for="savedSearch">Your Saved LinkedIn Search*:</label>
          <input @change="checkSearchExist" v-model="configuration.url" type="text"
                 placeholder=''
                 id="savedSearch" class="form-control form-control-lg" height="100%">
          <textarea class="form-control" readonly
                    style="white-space: pre-line;">{{ configuration.url }}</textarea>
          <p style="color: red" v-if="errorMissingSavedSearchId">We need the SavedSearchId URL, visit <a target="_blank"
                                                                                                         href="https://www.linkedin.com/help/sales-navigator/answer/a102024/save-a-lead-search-in-sales-navigator?lang=en">how
            to save my sales navigator search</a></p>
          <div class="custom-control custom-radio">
            <input v-model="configuration.mode" value="connection" type="radio"
                   class="custom-control-input"
                   id="connection"
                   name="mode"
                   checked>
            <label class="custom-control-label" for="connection">Connect to 2nd degree</label>
          </div>
          <div class="custom-control custom-radio">
            <input v-model="configuration.mode" value="message" type="radio"
                   class="custom-control-input" id="message"
                   name="mode">
            <label class="custom-control-label" for="message">Send Messages to 1st degree</label>
          </div>
          <div class="custom-control custom-radio">
            <input v-model="configuration.mode" value="getContactInformation" type="radio"
                   class="custom-control-input"
                   id="getContactInformation"
                   name="mode">
            <label class="custom-control-label" for="getContactInformation">Get Contact information
              from 1st degree</label>
          </div>
          <div>
            <label>Choose your CRM:</label>
            <b-form-select @change="validatedCrmToken" v-model="selectedCRM"
                           :options="optionCRM"></b-form-select>
            <div v-if="selectedCRM!=='zoho' && selectedCRM!==''">
              <label for="pipedriver_token">API Key: <span style="font-size: small">Don't know how to get your API key? <a
                :href=this.$constants.crmHelpGetApiToken[selectedCRM].link target="_blank">click here</a></span></label>
              <input v-model="configuration.pipedriveToken" type="text"
                     placeholder=''
                     id="pipedriver_token" class="form-control form-control-lg"
              >
            </div>
          </div>
        </card>
      </tab-content>
      <tab-content :title=step2
                   icon="fas fa-comment-alt  fa-2x">
        <card>
          <div v-if="configuration.mode!=='getContactInformation'">

          </div>
          <div v-else>
            <p> Proceed to the next step please</p>
          </div>
          <div v-if="this.configuration.mode==='connection'">
            MAX CHARACTER: 300
            <div>
              <label for="template1">Note template #1: </label>
              <span style="float:right">{{ charactersLeftTemplate1Connection }}</span>
              <br>
              <span>Saved Templates</span>
              <b-form-select style="margin-bottom: 6px;" v-model="selectedReusableTemplate1"
                             @change="configuration.template1=selectedReusableTemplate1"
                             :options="optionsReusableTemplates"></b-form-select>
              <textarea onkeypress="if(event.keyCode==13){return false;}" maxlength="306"
                        v-model="configuration.template1"
                        class="form-control" id="template1" rows="5"></textarea>
              Insert :
              <b-row>
                <b-col cols="8">
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_user ')">
                    First name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_last_name ')">
                    Last name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_title ')">
                    Job Title
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_location ')">
                    User location
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_company ')">
                    Company name
                  </b-button>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <input style="margin-right: 15px" v-model="nameReusableTemplate1"
                             placeholder="Name of your template">
                      <p v-if="errorMissingNameTemplate1" style="color: red;font-size: 9px">Please
                        put a name for your template</p>
                      <p v-if="ConfirmSavedTemplate1" style="color: green;font-size: 9px">Saved</p>
                    </b-col>
                    <b-col>
                      <b-button variant="info" size="sm"
                                @click="saveReusableTemplate('template1')">
                        Save my note as template
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
            <div>
              <label for="template2">Note template #2: </label>
              <span style="float:right">{{ charactersLeftTemplate2Connection }}</span>
              <br>
              <span>Saved Templates</span>
              <b-form-select style="margin-bottom: 6px;" v-model="selectedReusableTemplate2"
                             @change="configuration.template2=selectedReusableTemplate2"
                             :options="optionsReusableTemplates"></b-form-select>
              <textarea onkeypress="if(event.keyCode==13){return false;}" maxlength="306"
                        v-model="configuration.template2"
                        class="form-control" id="template2" rows="5"></textarea>
              Insert :
              <b-row>
                <b-col cols="8">
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_user ')">
                    First name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_last_name ')">
                    Last name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_title ')">
                    Job Title
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_location ')">
                    User location
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_company ')">
                    Company name
                  </b-button>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <input style="margin-right: 15px" v-model="nameReusableTemplate2"
                             placeholder="Name of your template">
                      <p v-if="errorMissingNameTemplate2" style="color: red;font-size: 9px">Please
                        put a name for your template</p>
                      <p v-if="ConfirmSavedTemplate2" style="color: green;font-size: 9px">Saved</p>
                    </b-col>
                    <b-col>
                      <b-button variant="info" size="sm"
                                @click="saveReusableTemplate('template2')">
                        Save my note as template
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <div v-if="this.configuration.mode==='message'">
            <span> LinkedIn recommend message no more than 500 characters for messaging</span>
            <div>
              <label for="template1message">Message template #1: </label>
              <span style="float:right">{{ charactersLeftTemplate1Messaging }}</span>
              <br>
              <span>Saved Templates</span>
              <b-form-select style="margin-bottom: 6px;" v-model="selectedReusableTemplate1"
                             @change="configuration.template1=selectedReusableTemplate1"
                             :options="optionsReusableTemplates"></b-form-select>
              <textarea onkeypress="if(event.keyCode==13){return false;}"
                        v-model="configuration.template1"
                        class="form-control" id="template1message" rows="5"></textarea>

              Insert :
              <b-row>
                <b-col cols="8">
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_user ')">
                    First name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_last_name ')">
                    Last name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_title ')">
                    Job Title
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_location ')">
                    User location
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template1 = configuration.template1.concat('@linkedin_company ')">
                    Company name
                  </b-button>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <input style="margin-right: 15px" v-model="nameReusableTemplate1"
                             placeholder="Name of your template">
                      <p v-if="errorMissingNameTemplate1" style="color: red;font-size: 9px">Please
                        put a name for your template</p>
                      <p v-if="ConfirmSavedTemplate1" style="color: green;font-size: 9px">Saved</p>
                    </b-col>
                    <b-col>
                      <b-button variant="info" size="sm"
                                @click="saveReusableTemplate('template1')">
                        Save my note as template
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
            <div>
              <label for="template2message">Message template #2: </label>
              <span style="float:right">{{ charactersLeftTemplate2Messaging }}</span>
              <br>
              <span>Saved Templates</span>
              <b-form-select style="margin-bottom: 6px;" v-model="selectedReusableTemplate2"
                             @change="configuration.template2=selectedReusableTemplate2"
                             :options="optionsReusableTemplates"></b-form-select>
              <textarea onkeypress="if(event.keyCode===13){return false;}"
                        v-model="configuration.template2"
                        class="form-control" id="template2message" rows="5"></textarea>
              Insert :
              <b-row>
                <b-col cols="8">
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_user ')">
                    First name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_last_name ')">
                    Last name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_title ')">
                    Job Title
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_location ')">
                    User location
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.template2 = configuration.template2.concat('@linkedin_company ')">
                    Company name
                  </b-button>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <input style="margin-right: 15px" v-model="nameReusableTemplate2"
                             placeholder="Name of your template">
                      <p v-if="errorMissingNameTemplate2" style="color: red;font-size: 9px">Please
                        put a name for your template</p>
                      <p v-if="ConfirmSavedTemplate2" style="color: green;font-size: 9px">Saved</p>
                    </b-col>
                    <b-col>
                      <b-button variant="info" size="sm"
                                @click="saveReusableTemplate('template2')">
                        Save my note as template
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <div v-if="configuration.mode==='message'">
            <label>Last time you contacted: </label>
            <p>Users that you have contacted after
              <datepicker placeholder="Pick a day"
                          format="yyyy/MM/dd" :value="new Date()"
                          v-model="configuration.dateThreshold"></datepicker>
              will not be contacted.
            </p>
          </div>
          <card v-if="this.configuration.mode==='connection'">
            <br>
            <base-checkbox v-model="followMessageState" class="mb-3">
              I want to send follow-up message to accepted requests<br>
              <b>Note: The follow-up messages will be sent during working hours, for better experience</b>
            </base-checkbox>
          </card>
          <div v-if="followMessageState">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button style="background-color: lightgreen !important;color:black;font-size: 25px"
                        block href="#"
                        v-b-toggle.tip-1 variant="info">Tips
              </b-button>
            </b-card-header>

            <b-collapse id="tip-1" class="mt-2">
              <b-card>
                <p class="card-text" style="font-style: italic;"> First, you want to thank them for accepting your
                  connection
                  request. This is not
                  only important so that you are polite but also because it’s easy to forget about
                  somebody who connected to you on LinkedIn. This way you remind the person how you
                  initially got connected.</p>
                <p style="font-weight: bold;">Research by Boomerang shows that one of the most effective ways to close
                  an email
                  before typing in your name is simply, “Thanks.”</p>
              </b-card>
            </b-collapse>
            <label>Tips:</label>

            <span> LinkedIn recommend message no more than 500 characters for messaging</span>
            <div>
              <label for="template1message">Follow up template #1: </label>
              <span style="float:right">{{ charactersLeftFollow1Messaging }}</span>
              <br>
              <span>Saved Templates</span>
              <b-form-select style="margin-bottom: 6px;" v-model="selectedReusableFollow1"
                             @change="configuration.follow1=selectedReusableFollow1"
                             :options="optionsReusableTemplates"></b-form-select>
              <textarea onkeypress="if(event.keyCode==13){return false;}"
                        v-model="configuration.follow1"
                        class="form-control" id="follow1message" rows="5"></textarea>
              Insert :
              <b-row>
                <b-col cols="8">
                  <b-button variant="primary" size="sm"
                            @click="configuration.follow1 = configuration.follow1.concat('@linkedin_user ')">
                    First name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.follow1 = configuration.follow1.concat('@linkedin_last_name ')">
                    Last name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.follow1 = configuration.follow1.concat('@linkedin_title ')">
                    Job Title
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.follow1 = configuration.follow1.concat('@linkedin_company ')">
                    Company name
                  </b-button>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <input style="margin-right: 15px" v-model="nameReusableFollow1"
                             placeholder="Name of your template">
                      <p v-if="errorMissingNameFollow1" style="color: red;font-size: 9px">Please
                        put a name for your template</p>
                      <p v-if="ConfirmSavedFollow1" style="color: green;font-size: 9px">Saved</p>
                    </b-col>
                    <b-col>
                      <b-button variant="info" size="sm"
                                @click="saveReusableTemplate('follow1')">
                        Save my note as template
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>

              </b-row>
            </div>
            <div>
              <label for="template2message">Follow up template #2: </label>
              <span style="float:right">{{ charactersLeftFollow2Messaging }}</span>
              <br>
              <span>Saved Templates</span>
              <b-form-select style="margin-bottom: 6px;" v-model="selectedReusableFollow2"
                             @change="configuration.follow2=selectedReusableFollow2"
                             :options="optionsReusableTemplates"></b-form-select>
              <textarea onkeypress="if(event.keyCode==13){return false;}"
                        v-model="configuration.follow2"
                        class="form-control" id="follow2message" rows="5"></textarea>
              Insert :
              <b-row>
                <b-col cols="8">
                  <b-button variant="primary" size="sm"
                            @click="configuration.follow2 = configuration.follow2.concat('@linkedin_user ')">
                    First name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.follow2 = configuration.follow2.concat('@linkedin_last_name ')">
                    Last name
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.follow2 = configuration.follow2.concat('@linkedin_title ')">
                    Job Title
                  </b-button>
                  <b-button variant="primary" size="sm"
                            @click="configuration.follow2 = configuration.follow2.concat('@linkedin_company ')">
                    Company name
                  </b-button>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <input style="margin-right: 15px" v-model="nameReusableFollow2"
                             placeholder="Name of your template">
                      <p v-if="errorMissingNameFollow2" style="color: red;font-size: 9px">Please
                        put a name for your template</p>
                      <p v-if="ConfirmSavedFollow2" style="color: green;font-size: 9px">Saved</p>
                    </b-col>
                    <b-col>
                      <b-button variant="info" size="sm"
                                @click="saveReusableTemplate('follow2')">
                        Save my note as template
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

        </card>
      </tab-content>
      <tab-content :title=step3
                   icon="fas fa-calendar-alt fa-2x">
        <div>

          <p>Use Existing Schedule</p>
          <b-form-select style="margin-bottom: 6px;" v-model="selectedReusableScheduleConfiguration"
                         @change="loadSavedScheduledConfiguration"
                         :options="optionsReusableScheduleConfiguration"></b-form-select>
          <p>Please choose the timezone for your configuration to meet the timezone of your targeted
            audience. </p>
          <b-form-select @change="this.setTimeZoneForSchedule" v-model="selectedTimeZone"
                         :options="optionsOffsetTimeZone"></b-form-select>
        </div>

        <div role="tablist" v-if="selectedTimeZone!=='0'">
          <p>The timezone of your configuration is {{ selectedTimeZone }}</p>
          <p> YourSynchronicity runs your configuration 4 times per day, please choose when to run
            each one.</p>
          <b-alert variant="success" show>
            <p style="color: black">
              You can choose to run your configuration either by having the same schedule for all
              the
              days of the week, or if you want more accuracy, you can choose to schedule your
              configuration per day basis.
            </p>
            <p style="color: black">Based on LinkedIn, the
              <a target="_blank" rel="noopener noreferrer" style="color: white"
                 href="https://business.linkedin.com/talent-solutions/blog/writing-inmails/2016/data-reveals-the-best-time-to-send-inmails-and-the-answer-will-surprise-you">
                Data Reveals the Best Time to Send Requests
              </a>
              is at 8am ; 10am; 1pm; 3pm; 5pm and between Monday and
              Friday.
            </p>
            <p style="color: black"> If you are not sure when to send your requests, you can click
              on
              <b-button variant="outline-dark" @click="proposedYsySchedule">Choose this schedule
              </b-button>

            </p>
          </b-alert>
          <b-row>
            <b-col cols="6">
              <h4>Note:Two runs can't have the same time</h4>

            </b-col>
            <b-col>
              <b-row>
                <b-col cols="6">
                  <input style="float:right " v-model="nameReusableScheduleConfiguration"
                         placeholder="Name your schedule">
                  <p v-if="errorMissingNameScheduleConfiguration" style="color: red;font-size: 9px">
                    Please
                    put a name for your template</p>
                  <p v-if="ConfirmSavedScheduleConfiguration" style="color: green;font-size: 9px">
                    Saved</p>
                </b-col>
                <b-col cols="6">
                  <b-button variant="info" size="sm"
                            @click="saveReusableScheduleConfiguration">
                    Save my schedule for future use
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button style="color:black" block v-b-toggle.accordion-alldays variant="info">Same
                schedule for all days
                of
                week
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-alldays" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <table style="width:100%">

                  <tr>
                    <th>Run</th>
                    <th>First Run</th>
                    <th>Second Run</th>
                    <th>Third Run</th>
                    <th>Fourth Run</th>
                    <th>Fifth Run</th>
                  </tr>
                  <tr>
                    <td>All Days of the week</td>
                    <td>
                      <VueCtkDateTimePicker id="addDay_1run" :noHeader=true
                                            :format=formatDateToReturn
                                            formatted="hh:mm a"
                                            :noLabel=true
                                            :only-time=true
                                            :minute-interval=60
                                            v-model="allDaysSchedule.first_run"/>

                    </td>
                    <td>
                      <VueCtkDateTimePicker id="addDay_2hrun" :noHeader=true
                                            :format=formatDateToReturn
                                            formatted="hh:mm a"
                                            :disabled-hours="[allDaysSchedule.first_run.split(':')[0]]"
                                            :only-time=true
                                            :noLabel=true
                                            :minute-interval=60
                                            v-model="allDaysSchedule.second_run"/>
                    </td>
                    <td>
                      <VueCtkDateTimePicker id="addDay_3hrun" :noHeader=true
                                            :format=formatDateToReturn
                                            formatted="hh:mm a"
                                            :only-time=true
                                            :disabled-hours="[allDaysSchedule.first_run.split(':')[0],allDaysSchedule.second_run.split(':')[0]]"
                                            :noLabel=true
                                            :minute-interval=60
                                            v-model="allDaysSchedule.third_run"/>
                    </td>
                    <td>
                      <VueCtkDateTimePicker id="addDay_4hrun" :noHeader=true
                                            :format=formatDateToReturn
                                            formatted="hh:mm a"
                                            :only-time=true
                                            :noLabel=true
                                            :disabled-hours="[allDaysSchedule.first_run.split(':')[0],allDaysSchedule.second_run.split(':')[0],allDaysSchedule.third_run.split(':')[0]]"
                                            :minute-interval=60
                                            v-model="allDaysSchedule.fourth_run"/>
                    </td>
                    <td>
                      <VueCtkDateTimePicker id="addDay_5hrun" :noHeader=true
                                            :format=formatDateToReturn
                                            formatted="hh:mm a"
                                            :only-time=true
                                            :noLabel=true
                                            :disabled-hours="[allDaysSchedule.first_run.split(':')[0],allDaysSchedule.second_run.split(':')[0],allDaysSchedule.third_run.split(':')[0],allDaysSchedule.fourth_run.split(':')[0]]"
                                            :minute-interval=60
                                            v-model="allDaysSchedule.fifth_run"/>
                    </td>

                  </tr>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button style="color:black" block v-b-toggle.accordion-perday variant="info">
                Schedule per day
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-perday" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div v-if="proceedToSchedulesDays">
                  <b-form-group label="Please choose the days that you want to schedule:">
                    <b-form-checkbox-group v-model="selectedAllDaysForFilter"
                                           :options="optionsSchedulesAllDaysForFilter"
                                           name="flavour-1a"
                    ></b-form-checkbox-group>
                  </b-form-group>

                  <button type="button" class="btn btn-primary" @click="changeAllDaysForSchedule">
                    Schedule
                  </button>
                </div>
                <button type="button" class="btn btn-primary" v-else
                        @click="proceedToSchedulesDays=true">Back to choose days
                </button>
                <div v-if="!proceedToSchedulesDays">
                  <p>Please choose the run you want for each day:
                    <span class="font-weight-bold">Timezone:{{ selectedTimeZone }}</span></p>
                  <table style="width:100%">
                    <tr>
                      <th>Run</th>
                      <th>First Run</th>
                      <th>Second Run</th>
                      <th>Third Run</th>
                      <th>Fourth Run</th>
                      <th>Fifth Run</th>
                    </tr>
                    <tr v-if="'mondaySchedule' in daysSchedule">
                      <td>Monday</td>
                      <td>
                        <VueCtkDateTimePicker id="monday_1run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :noLabel=true
                                              :only-time=true
                                              :minute-interval=60
                                              v-model="daysSchedule.mondaySchedule.first_run"/>

                      </td>
                      <td>
                        <VueCtkDateTimePicker id="monday_2run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.mondaySchedule.first_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.mondaySchedule.second_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="monday_3run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.mondaySchedule.first_run.split(':')[0],daysSchedule.mondaySchedule.second_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.mondaySchedule.third_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="monday_4run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.mondaySchedule.first_run.split(':')[0],daysSchedule.mondaySchedule.second_run.split(':')[0],daysSchedule.mondaySchedule.third_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.mondaySchedule.fourth_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="monday_5run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.mondaySchedule.first_run.split(':')[0],daysSchedule.mondaySchedule.second_run.split(':')[0],daysSchedule.mondaySchedule.third_run.split(':')[0],daysSchedule.mondaySchedule.fourth_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.mondaySchedule.fifth_run"/>
                      </td>

                    </tr>
                    <tr v-if="'tuesdaySchedule' in daysSchedule">
                      <td>Tuesday</td>
                      <td>
                        <VueCtkDateTimePicker id="tuesday_1run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :noLabel=true
                                              :only-time=true
                                              :minute-interval=60
                                              v-model="daysSchedule.tuesdaySchedule.first_run"/>

                      </td>
                      <td>
                        <VueCtkDateTimePicker id="tuesday_2run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.tuesdaySchedule.first_run.split(':')[0],]"
                                              :minute-interval=60
                                              v-model="daysSchedule.tuesdaySchedule.second_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="tuesday_3run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.tuesdaySchedule.first_run.split(':')[0],daysSchedule.tuesdaySchedule.second_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.tuesdaySchedule.third_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="tuesday_4run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.tuesdaySchedule.first_run.split(':')[0],daysSchedule.tuesdaySchedule.second_run.split(':')[0],daysSchedule.tuesdaySchedule.third_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.tuesdaySchedule.fourth_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="tuesday_5run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.tuesdaySchedule.first_run.split(':')[0],daysSchedule.tuesdaySchedule.second_run.split(':')[0],daysSchedule.tuesdaySchedule.third_run.split(':')[0],daysSchedule.tuesdaySchedule.fourth_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.tuesdaySchedule.fifth_run"/>
                      </td>

                    </tr>
                    <tr v-if="'wednesdaySchedule' in daysSchedule">
                      <td>Wednesday</td>
                      <td>
                        <VueCtkDateTimePicker id="wednesday_1run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :noLabel=true

                                              :only-time=true
                                              :minute-interval=60
                                              v-model="daysSchedule.wednesdaySchedule.first_run"/>

                      </td>
                      <td>
                        <VueCtkDateTimePicker id="wednesday_2run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.wednesdaySchedule.first_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.wednesdaySchedule.second_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="wednesday_3run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.wednesdaySchedule.first_run.split(':')[0],daysSchedule.wednesdaySchedule.second_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.wednesdaySchedule.third_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="wednesday_4run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.wednesdaySchedule.first_run.split(':')[0],daysSchedule.wednesdaySchedule.second_run.split(':')[0],daysSchedule.wednesdaySchedule.third_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.wednesdaySchedule.fourth_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="wednesday_5run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.wednesdaySchedule.first_run.split(':')[0],daysSchedule.wednesdaySchedule.second_run.split(':')[0],daysSchedule.wednesdaySchedule.third_run.split(':')[0],daysSchedule.wednesdaySchedule.fourth_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.wednesdaySchedule.fifth_run"/>
                      </td>
                    </tr>
                    <tr v-if="'thursdaySchedule' in daysSchedule">
                      <td>Thursday</td>
                      <td>
                        <VueCtkDateTimePicker id="thursday_1run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :noLabel=true

                                              :only-time=true
                                              :minute-interval=60
                                              v-model="daysSchedule.thursdaySchedule.first_run"/>

                      </td>
                      <td>
                        <VueCtkDateTimePicker id="thursday_2run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.thursdaySchedule.first_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.thursdaySchedule.second_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="thursday_3run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.thursdaySchedule.first_run.split(':')[0],daysSchedule.thursdaySchedule.second_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.thursdaySchedule.third_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="thursday_4run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.thursdaySchedule.first_run.split(':')[0],daysSchedule.thursdaySchedule.second_run.split(':')[0],daysSchedule.thursdaySchedule.third_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.thursdaySchedule.fourth_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="thursday_5run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.thursdaySchedule.first_run.split(':')[0],daysSchedule.thursdaySchedule.second_run.split(':')[0],daysSchedule.thursdaySchedule.third_run.split(':')[0],daysSchedule.thursdaySchedule.fourth_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.thursdaySchedule.fifth_run"/>
                      </td>

                    </tr>
                    <tr v-if="'fridaySchedule' in daysSchedule">
                      <td>Friday</td>
                      <td>
                        <VueCtkDateTimePicker id="friday_1run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :noLabel=true

                                              :only-time=true
                                              :minute-interval=60
                                              v-model="daysSchedule.fridaySchedule.first_run"/>

                      </td>
                      <td>
                        <VueCtkDateTimePicker id="friday_2run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.fridaySchedule.first_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.fridaySchedule.second_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="friday_3run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.fridaySchedule.first_run.split(':')[0],daysSchedule.fridaySchedule.second_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.fridaySchedule.third_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="friday_4run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.fridaySchedule.first_run.split(':')[0],
                                            daysSchedule.fridaySchedule.second_run.split(':')[0],
                                            daysSchedule.fridaySchedule.third_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.fridaySchedule.fourth_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="friday_5run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.fridaySchedule.first_run.split(':')[0],
                                            daysSchedule.fridaySchedule.second_run.split(':')[0],
                                            daysSchedule.fridaySchedule.third_run.split(':')[0],
                                            daysSchedule.fridaySchedule.fourth_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.fridaySchedule.fifth_run"/>
                      </td>

                    </tr>
                    <tr v-if="'saturdaySchedule' in daysSchedule">
                      <td>Saturday</td>
                      <td>
                        <VueCtkDateTimePicker id="saturday_1run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :noLabel=true
                                              :only-time=true
                                              :minute-interval=60
                                              v-model="daysSchedule.saturdaySchedule.first_run"/>

                      </td>
                      <td>
                        <VueCtkDateTimePicker id="saturday_2run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.saturdaySchedule.first_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.saturdaySchedule.second_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="saturday_3run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.saturdaySchedule.first_run.split(':')[0],daysSchedule.saturdaySchedule.second_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.saturdaySchedule.third_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="saturday_4run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.saturdaySchedule.first_run.split(':')[0],daysSchedule.saturdaySchedule.second_run.split(':')[0],daysSchedule.saturdaySchedule.third_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.saturdaySchedule.fourth_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="saturday_5run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.saturdaySchedule.first_run.split(':')[0],daysSchedule.saturdaySchedule.second_run.split(':')[0],daysSchedule.saturdaySchedule.third_run.split(':')[0],daysSchedule.saturdaySchedule.fourth_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.saturdaySchedule.fifth_run"/>
                      </td>

                    </tr>
                    <tr v-if="'sundaySchedule' in daysSchedule">
                      <td>Sunday</td>
                      <td>
                        <VueCtkDateTimePicker id="sunday_1run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :noLabel=true

                                              :only-time=true
                                              :minute-interval=60
                                              v-model="daysSchedule.sundaySchedule.first_run"/>

                      </td>
                      <td>
                        <VueCtkDateTimePicker id="sunday_2run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.sundaySchedule.first_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.sundaySchedule.second_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="sunday_3run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.sundaySchedule.first_run.split(':')[0],daysSchedule.sundaySchedule.second_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.sundaySchedule.third_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="sunday_4run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.sundaySchedule.first_run.split(':')[0],daysSchedule.sundaySchedule.second_run.split(':')[0],daysSchedule.sundaySchedule.third_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.sundaySchedule.fourth_run"/>
                      </td>
                      <td>
                        <VueCtkDateTimePicker id="sunday_5run" :noHeader=true
                                              :format=formatDateToReturn
                                              formatted="hh:mm a"
                                              :only-time=true
                                              :noLabel=true
                                              :disabled-hours="[daysSchedule.sundaySchedule.first_run.split(':')[0],daysSchedule.sundaySchedule.second_run.split(':')[0],daysSchedule.sundaySchedule.third_run.split(':')[0],daysSchedule.sundaySchedule.fourth_run.split(':')[0]]"
                                              :minute-interval=60
                                              v-model="daysSchedule.sundaySchedule.fifth_run"/>
                      </td>

                    </tr>
                  </table>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

      </tab-content>
      <tab-content :title=step4 :before-change="checksFormsTemplate"
                   icon="fas fa-play fa-2x">

        <p>Summary of your configuration, if you want to edit, go back before submit </p>
        <label>Search Name</label>
        <textarea class="form-control" readonly
                  style="white-space: pre-line;">{{ configuration.ysySearchName }}</textarea>
        <label>Search URL</label>
        <textarea class="form-control" readonly
                  style="white-space: pre-line;">{{ configuration.url }}</textarea>
        <label>Configuration type : </label>
        <p>{{ this.step2 }}</p>
        <b-card no-body v-if="scheduleState==='accordion-alldays'" class="mb-1">
          <b-card-header header-tag="header" class="p-1">
            <b-button style="color:black" block
                      variant="info">
              Summary schedule configuration all days
            </b-button>
          </b-card-header>
          <b-card-body>
            <table style="width:100%">
              <tr>
                <th>Run</th>
                <th>First Run</th>
                <th>Second Run</th>
                <th>Third Run</th>
                <th>Fourth Run</th>
                <th>Fifth Run</th>
              </tr>
              <tr>
                <td>All Days of the week</td>
                <td v-for="runs in this.allDaysSchedule">
                  {{ runs }} {{ runs !== '' ? 'GMT' : '' }}
                </td>
              </tr>
            </table>
          </b-card-body>
        </b-card>
        <b-card no-body v-if="scheduleState==='accordion-perday'" class="mb-1">
          <b-card-header header-tag="header" class="p-1">
            <b-button style="color:black" block
                      variant="info">
              Summary schedule configuration per day
            </b-button>
          </b-card-header>


          <b-card-body>
            <table style="width:100%">
              <tr>
                <th>Run</th>
                <th>First Run</th>
                <th>Second Run</th>
                <th>Third Run</th>
                <th>Fourth Run</th>
                <th>Fifth Run</th>
              </tr>
              <tr v-if="'mondaySchedule' in daysSchedule">
                <td>Monday</td>
                <td v-for="runs in daysSchedule.mondaySchedule">
                  {{ runs }} {{ runs !== '' ? 'GMT' : '' }}
                </td>
              </tr>
              <tr v-if="'tuesdaySchedule' in daysSchedule">
                <td>Tuesday</td>
                <td v-for="runs in daysSchedule.tuesdaySchedule">
                  {{ runs }} {{ runs !== '' ? 'GMT' : '' }}
                </td>

              </tr>
              <tr v-if="'wednesdaySchedule' in daysSchedule">
                <td>Wednesday</td>
                <td v-for="runs in daysSchedule.wednesdaySchedule">
                  {{ runs }} {{ runs !== '' ? 'GMT' : '' }}
                </td>
              </tr>
              <tr v-if="'thursdaySchedule' in daysSchedule">
                <td>Thursday</td>
                <td v-for="runs in daysSchedule.thursdaySchedule">
                  {{ runs }} {{ runs !== '' ? 'GMT' : '' }}
                </td>

              </tr>
              <tr v-if="'fridaySchedule' in daysSchedule">
                <td>Friday</td>
                <td v-for="runs in daysSchedule.fridaySchedule">
                  {{ runs }} {{ runs !== '' ? 'GMT' : '' }}
                </td>
              </tr>
              <tr v-if="'saturdaySchedule' in daysSchedule">
                <td>Saturday</td>
                <td v-for="runs in daysSchedule.saturdaySchedule">
                  {{ runs }} {{ runs !== '' ? 'GMT' : '' }}
                </td>

              </tr>
              <tr v-if="'sundaySchedule' in daysSchedule">
                <td>Sunday</td>
                <td v-for="runs in daysSchedule.sundaySchedule">
                  {{ runs }} {{ runs !== '' ? 'GMT' : '' }}
                </td>
              </tr>
            </table>
          </b-card-body>

        </b-card>
        How the message 1 will look like:<br><textarea rows="4" class="form-control" readonly
                                                       style="white-space: pre-line;">{{
          configuration.template1.replace("RETURN",
            "\n")
        }}</textarea>
        How the message 2 will look like:<br><textarea rows="4" class="form-control" readonly
                                                       style="white-space: pre-line;">{{
          configuration.template2.replace("RETURN",
            "\n")
        }}</textarea>
        <div>
          How the follow up message 1 will look like:<br><textarea rows="4" class="form-control"
                                                                   readonly
                                                                   style="white-space: pre-line;">{{
            configuration.follow1.replace("RETURN",
              "\n")
          }}</textarea>
          How the follow up message 2 will look like:<br><textarea rows="4" class="form-control"
                                                                   readonly
                                                                   style="white-space: pre-line;">{{
            configuration.follow2.replace("RETURN",
              "\n")
          }}</textarea>
        </div>

      </tab-content>
      <tab-content :title=step5 :before-change="confirmSearchFinished"
                   icon="fas fa-search-dollar fa-2x">
        <ListUserInSearchResult v-if="startPollingResult" @event="resultSearch"
                                :saved-search-id=tmpUrlForSearchResult></ListUserInSearchResult>
      </tab-content>
    </form-wizard>
    <mdb-modal removeBackdrop :show="checkSearchAlreadyExist"
               @close="checkSearchAlreadyExist = false">
      <mdb-modal-header>
        <mdb-modal-title>Search already exist</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body> You already have this search in your existing configuration.<br><br><br><br>
        <b>You have spotted new connections in that search ?</b><br>
        You can always go to "Existing Configuration" on your left panel, and rewind the
        configuration named <b style="color: orangered">{{ nameSearchAlreadyExist }}</b>, by clicking
        on the following icon <i
          class="fas fa-history"></i> to start from the first page.
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="secondary" @click.native="checkSearchAlreadyExist = false">Close</mdb-btn>
        <router-link :to="{ name: 'Get User Config Sales Navigator'}">
          <mdb-btn color="primary" @click="checkSearchAlreadyExist = false">Go to "Existing
            configuration"
          </mdb-btn>
        </router-link>
        <!--        <mdb-btn color="primary">Save changes</mdb-btn>-->
      </mdb-modal-footer>
    </mdb-modal>
    <mdb-modal :show="checkConfigurationLimit" @close="checkConfigurationLimit = false" danger>
      <mdb-modal-header>
        <mdb-modal-title>Configuration Limit</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>You already reached the limit of active configuration of type <span
        style="color: blue;">{{ this.configuration.mode }}</span>, for the sake of your linkedIn
        accounts, to keep it under the radar you can only have one configuration of the same type
        active at once:
        <ul>
          <li>Nbr of active configuration for <i>{{ this.configuration.mode }}</i>:
            {{ this.actualCountConfiguration }}
          </li>
          <li>Limit for type <i>{{ this.configuration.mode }}</i>: {{ this.limit_configuration }}</li>
        </ul>
        <p style="font-size: 12px;padding-top: 5%;margin-bottom: -5%">Have any question on those
          limits? contact your <a href="mailto:support@yoursynchronicity.com">Administrator</a></p>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="primary" @click="checkConfigurationLimit = false">Close</mdb-btn>
        <!--        <mdb-btn color="primary">Save changes</mdb-btn>-->
      </mdb-modal-footer>
    </mdb-modal>
    <modal :show.sync="showCheckMessageTemplate"
           gradient="danger"
           modal-classes="modal-danger modal-dialog-centered">
      <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is
        required</h6>
      <div class="py-3 text-center">
        <i class="ni ni-bell-55 ni-3x"></i>
        <h4 class="heading mt-4">You should read this!</h4>
        <p>The {{ templateMessageIssue }} does not contain any YourSynchronicity keyword
          (ie:@linkedin_user), and hence
          it'll not be customize to each user, are you
          sure that this message template is valid ?</p>
      </div>

      <template slot="footer">

        <base-button type="link"
                     class="ml-auto text-white"
                     @click="showCheckMessageTemplate = false">
          Close
        </base-button>
        <base-button type="white" @click="addNewConfiguration">Yes</base-button>
      </template>
    </modal>
    <b-modal no-close-on-backdrop v-model="showNextResultsModel" centered id="modal-next-results"
             title="Preview your search"
             no-close-on-esc ok-only hide-header-close ok-title="Continue">
      <p class="my-4">In the next screen you will have a preview of your search !</p>
      <p>You will be able to discard some users from the search so that they don't receive your request.</p>
      <p>For instance your can search for the users that does not have a profile picture and discard them from your
        configuration.</p>
    </b-modal>
    <b-modal v-model="statusCompleteSearch" centered id="modal-close-results"
             title="Please confirm" @ok="completeSearch"
             hide-header-close ok-title="Finish">
      <p class="my-4">Do you want to close the preview of your result ?</p>

    </b-modal>
  </div>

</template>

<script>
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ListUserInSearchResult from "@/components/ysy/ListUserInSearchResult";

import {
  mdbAlert,
  mdbBtn,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbModalTitle
} from 'mdbvue';
import Datepicker from 'vuejs-datepicker';
import {refreshIdToken} from '../../util/utilsYsy'
///VueCtkDateTimePicker
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {

  name: "AddNewConfigurationSalesLinkedin",
  data() {
    return {
      //showOverlayConfiguration
      statusCompleteSearch: false,
      showNextResultsModel: false,
      startPollingResult: false,
      tmpUrlForSearchResult: '',
      singletonPassLinkedin: false,

      // ADD FOR SCHEDULER
      ValueTimePicked: null,
      selectedTimeZone: "0",
      formatDateToReturn: "hh:mm a",
      optionsOffsetTimeZone: [],
      allDaysSchedule: {
        "first_run": '',
        "second_run": '',
        "third_run": '',
        "fourth_run": '',
        "fifth_run": ''
      },
      daysSchedule: {
        mondaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        tuesdaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        wednesdaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        thursdaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        fridaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        saturdaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        sundaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        }
      },

      scheduleState: '',
      selectedAllDaysForFilter: [],
      optionsSchedulesAllDaysForFilter: [
        {text: 'Monday', value: 'mondaySchedule'},
        {text: 'Tuesday', value: 'tuesdaySchedule'},
        {text: 'Wednesday', value: 'wednesdaySchedule'},
        {text: 'Thursday', value: 'thursdaySchedule'},
        {text: 'Friday', value: 'fridaySchedule'},
        {text: 'Saturday', value: 'saturdaySchedule'},
        {text: 'Sunday', value: 'sundaySchedule'}
      ],
      proceedToSchedulesDays: true,
      selectedWantedDay: '',
      errorMissingNameScheduleConfiguration: false,
      ConfirmSavedScheduleConfiguration: false,
      nameReusableScheduleConfiguration: "",
      selectedReusableScheduleConfiguration: null,
      optionsReusableScheduleConfiguration: [],
      ///END ADD FOR SCHEDULER
      maintenanceYsYSalesNavigator: this.$store.getters.getMaintenanceYsYSalesNavigator,
      step1: 'Your audience',
      step2: 'Your messages',
      step3: 'Schedule your campaign',
      step4: 'Summary',
      step5: 'Preview your search',
      loadingWizard: false,
      errorMsg: null,
      optionCRM: [
        {value: '', text: ''},
        {value: 'pipedrive', text: 'Pipedrive CRM'},
        {value: 'hubspot', text: 'Hubspot CRM'},
        {value: 'mailchimp', text: 'mailchimp CRM'},
        {value: 'zoho', text: 'Zoho CRM'}
      ],
      selectedCRM: '',
      errorMissingYsySearchName: false,
      errorMissingSavedSearchId: false,
      followMessageState: false,
      todayDate: '',
      showCheckMessageTemplate: false,
      // savedThereusableTemplate
      errorMissingNameTemplate1: false,
      errorMissingNameTemplate2: false,
      errorMissingNameFollow1: false,
      errorMissingNameFollow2: false,
      ConfirmSavedTemplate1: false,
      ConfirmSavedTemplate2: false,
      ConfirmSavedFollow1: false,
      ConfirmSavedFollow2: false,
      nameReusableTemplate1: "",
      nameReusableTemplate2: "",
      nameReusableFollow1: "",
      nameReusableFollow2: "",
      selectedReusableTemplate1: null,
      selectedReusableTemplate2: null,
      selectedReusableFollow1: null,
      selectedReusableFollow2: null,
      optionsReusableTemplates: [],
      /////////////////////////////
      dictConfigurationLimit: this.$store.getters.getDictConfigurationLimit,
      actualCountConfiguration: 0,
      templateMessageIssue: '',
      limit_configuration: 0,
      checkConfigurationLimit: false,
      //check configuration exist
      checkSearchAlreadyExist: false,
      nameSearchAlreadyExist: '',
      ///
      show: true,
      linkedin_type: "sales",
      haveAccount: this.$store.getters.getHaveAccount,
      configuration: {
        ysySearchName: '',
        pipedriveToken: '',
        emailLinkedin: '',
        mode: '',
        url: '',
        dateThreshold: '',
        template1: ' ',
        template2: ' ',
        follow1: ' ',
        follow2: ' '
      }
    };
  },
  components: {
    ListUserInSearchResult,
    Datepicker,
    mdbInput,
    VueCtkDateTimePicker,
    mdbContainer,
    FormWizard,
    TabContent,
    mdbAlert,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
  },
  methods: {
    refreshIdToken,
    resultSearch(value) {
      if (value === 'fail') {
        console.log('the search result has failed')
        this.$refs.SalesLinkedinConfigurationWizard.$emit('on-complete')
      }
    },
    completeSearch() {
      console.log('finish search')
      this.$refs.SalesLinkedinConfigurationWizard.$emit('on-complete')
    },
    confirmSearchFinished() {
      this.statusCompleteSearch = true
    },
    proposedYsySchedule() {
      let bestRun = {
        "first_run": '08:00 am'.concat(this.selectedTimeZone.split('GMT')[1], ":00"),
        "second_run": '10:00 am'.concat(this.selectedTimeZone.split('GMT')[1], ":00"),
        "third_run": '01:00 pm'.concat(this.selectedTimeZone.split('GMT')[1], ":00"),
        "fourth_run": '03:00 pm'.concat(this.selectedTimeZone.split('GMT')[1], ":00"),
        "fifth_run": '05:00 pm'.concat(this.selectedTimeZone.split('GMT')[1], ":00")
      };
      this.daysSchedule = {
        mondaySchedule: bestRun,
        tuesdaySchedule: bestRun,
        wednesdaySchedule: bestRun,
        thursdaySchedule: bestRun,
        fridaySchedule: bestRun
      };
      this.proceedToSchedulesDays = false;
      if (this.scheduleState !== 'accordion-perday') {
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'accordion-perday')
        }, 300);
      }

    },
    publishMyScheduleDays() {
      const self = this;
      return new Promise(resolve => {
        setTimeout(() => {

          self.daysSchedule = {
            mondaySchedule: {
              "first_run": '',
              "second_run": '',
              "third_run": '',
              "fourth_run": '',
              "fifth_run": ''
            },
            tuesdaySchedule: {
              "first_run": '',
              "second_run": '',
              "third_run": '',
              "fourth_run": '',
              "fifth_run": ''
            },
            wednesdaySchedule: {
              "first_run": '',
              "second_run": '',
              "third_run": '',
              "fourth_run": '',
              "fifth_run": ''
            },
            thursdaySchedule: {
              "first_run": '',
              "second_run": '',
              "third_run": '',
              "fourth_run": '',
              "fifth_run": ''
            },
            fridaySchedule: {
              "first_run": '',
              "second_run": '',
              "third_run": '',
              "fourth_run": '',
              "fifth_run": ''
            },
            saturdaySchedule: {
              "first_run": '',
              "second_run": '',
              "third_run": '',
              "fourth_run": '',
              "fifth_run": ''
            },
            sundaySchedule: {
              "first_run": '',
              "second_run": '',
              "third_run": '',
              "fourth_run": '',
              "fifth_run": ''
            }
          };
          for (var key of Object.keys(self.daysSchedule)) {
            if (!(self.selectedAllDaysForFilter.includes(key))) {
              delete self.daysSchedule[key];
            }

          }
          resolve('Updated');
        }, 300);
      });
    },
    async changeAllDaysForSchedule() {

      const result = await this.publishMyScheduleDays();
      this.proceedToSchedulesDays = false;
      console.log(result);
    },
    loadSavedScheduledConfiguration() {
      console.log('Load scheduled configuration', this.selectedReusableScheduleConfiguration)
      switch (this.selectedReusableScheduleConfiguration['schedule_type']) {
        case 'perday':
          this.daysSchedule = this.selectedReusableScheduleConfiguration['schedule_value'];
          this.selectedTimeZone = this.selectedReusableScheduleConfiguration['schedule_offset'];
          console.log('perday', this.selectedTimeZone);
          this.formatDateToReturn = "hh:mm a".concat(this.selectedTimeZone.split('GMT')[1], ":00")
          if (this.scheduleState !== 'accordion-perday') {
            setTimeout(() => {
              this.$root.$emit('bv::toggle::collapse', 'accordion-perday')
            }, 300);
          }

          break;
        case 'alldays':
          this.allDaysSchedule = this.selectedReusableScheduleConfiguration['schedule_value'];
          this.selectedTimeZone = this.selectedReusableScheduleConfiguration['schedule_offset'];
          console.log('allday', this.selectedTimeZone);
          this.formatDateToReturn = "hh:mm a".concat(this.selectedTimeZone.split('GMT')[1], ":00")
          if (this.scheduleState !== 'accordion-alldays') {
            setTimeout(() => {
              this.$root.$emit('bv::toggle::collapse', 'accordion-alldays')
            }, 300);
          }
          break;
      }
      this.proceedToSchedulesDays = false;
    },
    saveReusableScheduleConfiguration() {

      let type_schedule = '';
      if (this.scheduleState === 'accordion-perday' || this.scheduleState === '') {
        type_schedule = 'perday'
      }
      if (this.scheduleState === 'accordion-alldays') {
        type_schedule = 'alldays'
      }
      if (type_schedule === '') {
        console.log('Trigger choose a schedule')
      }
      console.log({
        username: this.$store.getters.getUser,
        email_linkedin: this.$store.getters.getEmailLinkedin,
        schedule_name: this.nameReusableScheduleConfiguration,
        schedule_type: type_schedule,
        schedule_value: type_schedule === 'perday' ? this.daysSchedule : this.allDaysSchedule,
        schedule_offset: this.selectedTimeZone,
        saveReusableSchedule: 'true'

      });
      const path = `${this.BACKEND_YSY}/linkedin/initState`;
      this.$http
        .post(path, JSON.stringify({
          username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          schedule_name: this.nameReusableScheduleConfiguration,
          schedule_type: type_schedule,
          schedule_value: type_schedule === 'perday' ? this.daysSchedule : this.allDaysSchedule,
          schedule_offset: this.selectedTimeZone,
          saveReusableSchedule: 'true'

        }), {
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${localStorage.id_token}`
          }
        })
        .then(res => {
          console.log(res);
          this.ConfirmSavedScheduleConfiguration = true;
          this.nameReusableScheduleConfiguration = '';
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          this.$router.push({name: 'login'});
        });
    },
    setTimeZoneForSchedule() {
      this.formatDateToReturn = "hh:mm a".concat(this.selectedTimeZone.split('GMT')[1], ":00");
      this.proceedToSchedulesDays = true;
      this.allDaysSchedule = {
        "first_run": '',
        "second_run": '',
        "third_run": '',
        "fourth_run": '',
        "fifth_run": ''
      };
      this.daysSchedule = {
        mondaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        tuesdaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        wednesdaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        thursdaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        fridaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        saturdaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        },
        sundaySchedule: {
          "first_run": '',
          "second_run": '',
          "third_run": '',
          "fourth_run": '',
          "fifth_run": ''
        }
      };
      console.log('setTimeZoneForSchedule', this.selectedTimeZone);
      if (this.scheduleState !== 'accordion-alldays') {
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'accordion-alldays')
        }, 300);
      }
    },
    async checkSearchExist() {
      if (this.configuration.url !== '') {
        const path = `${this.BACKEND_YSY}/linkedin/initState`;
        await this.$http
          .post(path, JSON.stringify({
            username: this.$store.getters.getUser,
            email_linkedin: this.$store.getters.getEmailLinkedin,
            saved_search_id: this.configuration.url,
            checkSearchExist: 'true'
          }), {
            headers: {
              'Content-type': 'application/json',
              'Authorization': `Bearer ${localStorage.id_token}`
            }
          })
          .then(res => {
            console.log(res);
            if (res.data.message === 'true') {
              this.nameSearchAlreadyExist = res.data['search_name'];
              this.checkSearchAlreadyExist = true;
            }
          })
          .catch(async error => {
            // eslint-disable-next-line
            var self = this;
            if (error.response.data.statusCode === "'401'") {
              console.error('Unauthorized', error.response.data);
              await this.refreshIdToken().then(function (result) {
                console.log("res promise", result); // "Stuff worked!"
                self.checkSearchExist();
              }, function (err) {
                console.log("it broke", err); // Error: "It broke"
                self.$router.push({name: 'login'});
              });

            } else {
              this.$router.push({name: 'login'});
            }
          });
      } else {
        console.log('empty url')
      }

    },
    validatedCrmToken() {
      if (this.selectedCRM === 'zoho') {
        if ("CrmToken" in localStorage) {
          let crmTokensYsy = JSON.parse(localStorage.CrmToken);
          this.configuration.pipedriveToken = crmTokensYsy[this.selectedCRM]
        } else {
          this.$notify({
            message:
              '<b>Please connect your Zoho CRM first, go to your Profile, under CRM Integration',
            timeout: 5000,
            icon: 'ni ni-bell-55',
            type: 'warning'
          });
          return
        }
      }
      console.log(' this.configuration.pipedriveToken', this.configuration.pipedriveToken)
    },
    saveReusableTemplate(message_type) {
      let templateName;
      let templateValue;
      switch (message_type) {
        case "template1":
          this.errorMissingNameTemplate1 = this.nameReusableTemplate1 === '';
          if (this.errorMissingNameTemplate1) {
            return
          }
          templateName = this.nameReusableTemplate1;
          templateValue = this.configuration.template1;
          break;
        case "template2":
          this.errorMissingNameTemplate2 = this.nameReusableTemplate2 === '';
          if (this.errorMissingNameTemplate2) {
            return
          }
          templateName = this.nameReusableTemplate2;
          templateValue = this.configuration.template2;
          break;
        case "follow1":

          this.errorMissingNameFollow1 = this.nameReusableFollow1 === '';
          if (this.errorMissingNameFollow1) {
            return
          }
          templateName = this.nameReusableFollow1;
          templateValue = this.configuration.follow1;
          break;
        case "follow2":
          this.errorMissingNameFollow2 = this.nameReusableFollow2 === '';
          if (this.errorMissingNameFollow2) {
            return
          }
          templateName = this.nameReusableFollow2;
          templateValue = this.configuration.follow2;
          break;
      }

      this.sendReusableTemplate(message_type, templateName, templateValue)

    },
    async sendReusableTemplate(message_type, TemplateName, TemplateContent) {

      const path = this.BACKEND_YSY + "/linkedin/initState";
      const headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      var payload = {
        email_linkedin: this.$store.getters.getEmailLinkedin,
        TemplateName: TemplateName,
        TemplateContent: TemplateContent,
        saveReusableTemplate: "true",
      };

      await this.$http
        .post(path, payload, {headers}).then(res => {
            console.log(res);
            switch (message_type) {
              case "template1":
                this.ConfirmSavedTemplate1 = true;
                this.nameReusableTemplate1 = '';
                break;
              case "template2":
                this.ConfirmSavedTemplate2 = true;
                this.nameReusableTemplate2 = '';
                break;
              case "follow1":
                this.ConfirmSavedFollow1 = true;
                this.nameReusableFollow1 = '';
                break;
              case "follow2":
                this.ConfirmSavedFollow2 = true;
                this.nameReusableFollow2 = '';
                break;
            }
          }
        ).catch(async error => {
          // eslint-disable-next-line
          console.error(error);
          var self = this;
          if (error.response.status === 401) {
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.sendReusableTemplate(message_type, TemplateName, TemplateContent)
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });

          }
        });
    },

    setLoading: function (value) {
      this.loadingWizard = value
    },
    handleValidation: function (isValid, tabIndex) {
      // console.log('Tab: ' + tabIndex + ' valid: ' + isValid)
    },
    handleErrorMessage: function (errorMsg) {
      this.errorMsg = errorMsg
    },
    getAllUrlParams(url) {

      // get query string from url (optional) or window
      var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

      // we'll store the parameters here
      var obj = {};

      // if query string exists
      if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
          // separate the keys and the values
          var a = arr[i].split('=');

          // set parameter name and value (use 'true' if empty)
          var paramName = a[0];
          var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

          // (optional) keep case consistent
          paramName = paramName.toLowerCase();
          if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

          // if the paramName ends with square brackets, e.g. colors[] or colors[2]
          if (paramName.match(/\[(\d+)?\]$/)) {

            // create key if it doesn't exist
            var key = paramName.replace(/\[(\d+)?\]/, '');
            if (!obj[key]) obj[key] = [];

            // if it's an indexed array e.g. colors[2]
            if (paramName.match(/\[\d+\]$/)) {
              // get the index value and add the entry at the appropriate position
              var index = /\[(\d+)\]/.exec(paramName)[1];
              obj[key][index] = paramValue;
            } else {
              // otherwise add the value to the end of the array
              obj[key].push(paramValue);
            }
          } else {
            // we're dealing with a string
            if (!obj[paramName]) {
              // if it doesn't exist, create property
              obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === 'string') {
              // if property does exist and it's a string, convert it to an array
              obj[paramName] = [obj[paramName]];
              obj[paramName].push(paramValue);
            } else {
              // otherwise add the property
              obj[paramName].push(paramValue);
            }
          }
        }
      }

      return obj;
    },
    validateAsync: function () {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (!this.configuration.url.includes('/posts/') && !this.configuration.url.includes('/groups/')) {
            if (this.configuration.mode === '' || this.configuration.url === '' || (this.selectedCRM !== '' && this.configuration.pipedriveToken === '') || this.configuration.ysySearchName === '' || this.getAllUrlParams(this.configuration.url).savedsearchid == null) {
              if (this.configuration.ysySearchName === '') {
                this.errorMissingYsySearchName = true
              }
              if (this.getAllUrlParams(this.configuration.url).savedsearchid == null) {
                console.log('this.getAllUrlParams(this.configuration.url)', this.getAllUrlParams(this.configuration.url))
                this.errorMissingSavedSearchId = true
              }
              this.notifyVue('warning');
              reject('Can not move to the next step')
            } else {
              this.errorMissingYsySearchName = false;
              this.errorMissingSavedSearchId = false;
              if (this.configuration.mode === 'connection') {
                this.step2 = "Connect with 2nd degree"
              }
              if (this.configuration.mode === 'message') {
                this.step2 = "Send message to 1st degree"
              }
              if (this.configuration.mode === 'getContactInformation') {
                this.step2 = "Get Contact information from your network"
              }

              resolve(true)
            }
          } else {
            if (this.configuration.mode === ''
              || this.configuration.url === ''
              || (this.selectedCRM !== '' && this.configuration.pipedriveToken === '') || this.configuration.ysySearchName === ''
            ) {

              if (this.configuration.ysySearchName === '') {
                this.errorMissingYsySearchName = true
              }
              this.notifyVue('warning');
              reject('Can not move to the next step')
            } else {
              this.errorMissingSavedSearchId = false;
              this.errorMissingYsySearchName = false;
              if (this.configuration.mode === 'connection') {
                this.step2 = "Connect with 2nd degree"
              }
              if (this.configuration.mode === 'message') {
                this.step2 = "Send message to 1st degree"
              }
              if (this.configuration.mode === 'getContactInformation') {
                this.step2 = "Get Contact information from your network"
              }

              resolve(true)
            }
          }
        }, 1000)
      })
    },
    notifyVue(type) {
      if (type === 'success') {
        this.$notify({
          message:
            '<b>Configuration added</b> - The dots started joining....',
          timeout: 5000,
          icon: 'ni ni-bell-55',
          type
        });
      } else if (type === 'warning') {
        this.$notify({
          message:
            '<b>Fail to add the configuration</b> - Please fill all the fields, before moving to next step',
          timeout: 5000,
          icon: 'ni ni-bell-55',
          type
        });
      } else if (type === 'danger') {
        this.$notify({
          message:
            '<b>Fail to add the configuration</b> - Please try again later...',
          timeout: 5000,
          icon: 'ni ni-bell-55',
          type
        });
      }
    },
    checksFormsTemplate() {
      if (this.singletonPassLinkedin) {
        this.showCheckMessageTemplate = false;
        return true
      }
      if (!this.configuration.template1.includes('@linkedin_user') && this.configuration.mode !== 'getContactInformation') {
        this.templateMessageIssue = 'message 1';
        if (!this.configuration.template2.includes('@linkedin_user') && this.configuration.mode !== 'getContactInformation') {
          this.templateMessageIssue = 'messages';
        }
        this.showCheckMessageTemplate = true;
      } else if (!this.configuration.template2.includes('@linkedin_user') && this.configuration.mode !== 'getContactInformation') {
        this.templateMessageIssue = 'message 2';
        this.showCheckMessageTemplate = true;
      } else {
        this.addNewConfiguration()
        this.startPollingResult = true
      }
    }
    ,

    resetForm() {
      this.followMessageState = false;
      this.statusCompleteSearch = false;
      var self = this; //you need this because *this* will refer to Object.keys below`
      //Iterate through each object field, key is name of the object field`
      Object.keys(this.configuration).forEach(function (key, index) {
        self.configuration[key] = '';
      });
      this.$router.push({name: 'Get User Config Sales Navigator'})
    }
    ,
    addNewConfiguration() {
      console.log('Push New Configuration')
      this.showNextResultsModel = true;
      if (this.configuration.mode === '' || this.configuration.url === '') {
        this.notifyVue('warning');
        return;
      }

      if (this.configuration.mode === 'message') {
        if (this.configuration.dateThreshold !== '') {
          if (typeof this.configuration.dateThreshold === 'object') {
            this.configuration.dateThreshold = this.configuration.dateThreshold.toISOString().split("T")[0].replace("-", "/").replace("-", "/")
            console.log('this.configuration.dateThreshold', this.configuration.dateThreshold)
            return
          }
        } else {
          var today = new Date();
          this.configuration.dateThreshold = today.toISOString().split("T")[0].replace("-", "/").replace("-", "/")
        }
      }

      const path = this.BACKEND_YSY + "/linkedin/initState";
      if (this.configuration.mode === 'getContactInformation' || this.configuration.mode === 'message') {
        this.configuration.url = this.configuration.url + '&facetNetwork=%5B"F"%5D'
      }
      if (this.configuration.mode === 'connection') {
        this.configuration.url = this.configuration.url + '&facetNetwork=%5B"S"%5D'
      }
      if (this.dictConfigurationLimit[this.configuration.mode]['count'] >= this.dictConfigurationLimit[this.configuration.mode]['limit']) {
        this.actualCountConfiguration = this.dictConfigurationLimit[this.configuration.mode]['count'];
        this.limit_configuration = this.dictConfigurationLimit[this.configuration.mode]['limit'];
        console.log('Rejecting the demand');
        this.checkConfigurationLimit = true;
        if (this.configuration.mode === 'message') {
          this.configuration.dateThreshold = ''
        }
        return
      }

      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      var payload = {
        email_linkedin: this.$store.getters.getEmailLinkedin,
        url_linkedin_search: this.configuration.url,
        pipedrive_token: this.selectedCRM + '@YSY@' + this.configuration.pipedriveToken,
        ysySearchName: this.configuration.ysySearchName,
        username: this.$store.getters.getUser,
        mode: this.configuration.mode,
        linkedin_type: this.linkedin_type,
        date_threshold: this.configuration.dateThreshold,
        body_message: [this.configuration.template1, this.configuration.template2],
        body_follow: [this.configuration.follow1, this.configuration.follow2],
      };

      // SCHEDULE CONFIGURATION
      if (this.scheduleState === 'accordion-perday' || this.scheduleState === '') {
        payload['schedule_days'] = this.daysSchedule
      }
      if (this.scheduleState === 'accordion-alldays') {
        payload['schedule_days'] = {
          mondaySchedule: this.allDaysSchedule,
          tuesdaySchedule: this.allDaysSchedule,
          wednesdaySchedule: this.allDaysSchedule,
          thursdaySchedule: this.allDaysSchedule,
          fridaySchedule: this.allDaysSchedule,
          saturdaySchedule: this.allDaysSchedule,
          sundaySchedule: this.allDaysSchedule
        };
      }
      // END : SCHEDULE CONFIGURATION
      this.tmpUrlForSearchResult = this.configuration.url;
      this.startPollingResult = true
      this.singletonPassLinkedin = true
      this.showNextResultsModel = true
      this.$refs.SalesLinkedinConfigurationWizard.nextTab()
      this.$http
        .post(path, payload, {headers}).then(async res => {
            console.log(res);
            this.$store.commit('changeDictConfigurationLimit', {
              'mode': payload['mode'],
              'previous': this.dictConfigurationLimit[payload['mode']].count,
              'rule': '+'
            });

            this.notifyVue('success')
          }
        ).catch(async error => {
          // eslint-disable-next-line
          var self = this;
          this.startPollingResult = false;
          console.error(error);
          this.notifyVue('danger');
        });
    }
  }
  ,
  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (isJustShown === true && (collapseId === 'accordion-perday' || collapseId === 'accordion-alldays')) {
        this.scheduleState = collapseId;
      }
    })
  },
  created() {
    this.configuration.emailLinkedin = this.$store.getters.getEmailLinkedin;

    var self = this;
    let dictReusableTemplates = JSON.parse(localStorage.ReusableTemplates);
    dictReusableTemplates.forEach(function (item, index) {
      // console.log(item, index);
      self.optionsReusableTemplates.push(
        {value: item['template_value'], text: item['template_name']}
      )
    });

    let dictReusableSchedules = JSON.parse(localStorage.ReusableSchedules);
    dictReusableSchedules.forEach(function (item, index) {
      self.optionsReusableScheduleConfiguration.push(
        {value: item['schedule_value'], text: item['schedule_name']}
      )
    });
    var ct_time_zone;
    for (ct_time_zone = -12; ct_time_zone <= 12; ct_time_zone++) {
      let _value = ct_time_zone >= 0 ? "GMT+".concat(ct_time_zone) : "GMT".concat(ct_time_zone);
      this.optionsOffsetTimeZone.push(
        {
          value: _value,
          text: _value
        },
      )
    }
  }
  ,
  computed: {
    charactersLeftTemplate1Connection() {
      var char = this.configuration.template1.length;
      var limit = 300;
      return (limit - char) + " / " + limit + " characters remaining";
    }
    ,
    charactersLeftTemplate2Connection() {
      var char = this.configuration.template2.length;
      var limit = 300;
      return (limit - char) + " / " + limit + " characters remaining";
    }
    ,
    charactersLeftTemplate1Messaging() {
      var char = this.configuration.template1.length;
      var limit = 500;
      return (limit - char) + " / " + limit + " characters remaining";
    }
    ,
    charactersLeftTemplate2Messaging() {
      var char = this.configuration.template2.length;
      var limit = 500;
      return (limit - char) + " / " + limit + " characters remaining";
    },
    charactersLeftFollow1Messaging() {
      var char = this.configuration.follow1.length;
      var limit = 500;
      return (limit - char) + " / " + limit + " characters remaining";
    }
    ,
    charactersLeftFollow2Messaging() {
      var char = this.configuration.follow2.length;
      var limit = 500;
      return (limit - char) + " / " + limit + " characters remaining";
    }
  }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
}
</style>
